module.exports = __webpack_public_path__ + "static/media/h8_give.ea15bd48.webp";